'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _formatCurrency = require('../../../utils/formatCurrency');var _formatCurrency2 = _interopRequireDefault(_formatCurrency);
var _PropertySummary = require('./PropertySummary.scss');var _PropertySummary2 = _interopRequireDefault(_PropertySummary);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var nisSign = '₪';

function formatPrice(price, isRtl, searchOption, translate, currency) {
  var currencySymbol = currency ? (0, _formatCurrency2.default)(currency) : nisSign;
  var currencySign = price ? currencySymbol : '';
  if (searchOption === 'forShortRent') {
    return isRtl ?
    _react2.default.createElement('span', null, price + ' ' + currencySign + '/' + translate('day')) :
    _react2.default.createElement('span', null, translate('day') + '/' + currencySign + ' ' + price);
  }
  return isRtl ?
  _react2.default.createElement('span', null, price, ' ', currencySign) :
  _react2.default.createElement('span', null, currencySign, ' ', price);
}

var PropertySummary = function PropertySummary(_ref)













{var translate = _ref.translate,_ref$data = _ref.data,price = _ref$data.price,currency = _ref$data.currency,pricePerSqMeter = _ref$data.pricePerSqMeter,_ref$data$address = _ref$data.address,cityName = _ref$data$address.cityName,streetName = _ref$data$address.streetName,houseNumber = _ref$data$address.houseNumber,countryName = _ref$data$address.countryName,neighborhood = _ref$data$address.neighborhood,additionalInfo = _ref$data.additionalInfo,isCottage = _ref$data.isCottage,isForeign = _ref$data.isForeign,className = _ref.className,isRtl = _ref.isRtl,isMobile = _ref.isMobile,searchOption = _ref.searchOption;
  var currencySymbol = currency ? (0, _formatCurrency2.default)(currency) : nisSign;
  return (
    _react2.default.createElement('div', { className: className },
      _react2.default.createElement('div', { className: _PropertySummary2.default.priceLine },
        formatPrice(price, isRtl, searchOption, translate, currency), '\xA0\xA0',
        isMobile && _react2.default.createElement('br', null),
        !!pricePerSqMeter && _react2.default.createElement('span', { className: _PropertySummary2.default.pricePerSqM }, pricePerSqMeter, '\xA0', currencySymbol, translate('perSqMeter'))),


      _react2.default.createElement('h1', { className: _PropertySummary2.default.addressLine },
        cityName ?
        _react2.default.createElement('div', null,
          _react2.default.createElement('p', { className: _PropertySummary2.default.streetName }, streetName, ' ', houseNumber),
          _react2.default.createElement('div', { className: _PropertySummary2.default.neighborhood },
            neighborhood && neighborhood !== cityName && _react2.default.createElement('div', null, neighborhood, ', \xA0'),
            _react2.default.createElement('div', null, cityName, isForeign && ', ' + countryName))) :


        ''),


      _react2.default.createElement('div', { className: _PropertySummary2.default.iconsGroup },
        additionalInfo && additionalInfo.rooms ?
        _react2.default.createElement('div', null,
          _react2.default.createElement('span', { className: 'icon icon-door' }),
          _react2.default.createElement('span', { property: 'numberOfRooms', className: _PropertySummary2.default.iconsText },
            translate('rooms'), ': ', additionalInfo.rooms)) :


        null,

        additionalInfo && additionalInfo.floor ?
        _react2.default.createElement('div', null,
          _react2.default.createElement('span', { className: 'icon icon-floor' }),
          _react2.default.createElement('span', { className: _PropertySummary2.default.iconsText },
            translate('details', '' + (isCottage ? 'floors' : 'floor')), ' ', additionalInfo.floor)) :


        null,






        additionalInfo && additionalInfo.area ?
        _react2.default.createElement('div', null,
          _react2.default.createElement('span', { className: 'icon icon-square' }),
          _react2.default.createElement('span', { className: _PropertySummary2.default.iconsText },
            translate('square') + ': ' + additionalInfo.area)) :


        null,

        additionalInfo && additionalInfo.parkingSpots ?
        _react2.default.createElement('div', null,
          _react2.default.createElement('span', { className: 'icon icon-parkingSpot' }),
          _react2.default.createElement('span', { className: _PropertySummary2.default.iconsText },
            additionalInfo.parkingSpots === 1 ?
            translate('parkingSpot') : translate('parkingSpots'), ': ',
            additionalInfo.parkingSpots)) :


        null)));



};

PropertySummary.propTypes = {
  translate: _propTypes2.default.func,
  data: _propTypes2.default.object,
  className: _propTypes2.default.string,
  isRtl: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  searchOption: _propTypes2.default.string,
  isForeign: _propTypes2.default.bool };exports.default =


PropertySummary;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailedInfo/PropertySummary/PropertySummary.js
// module id = 2827
// module chunks = 0